var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2611_2871)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.00109,
    cy: 7.99987,
    r: 7.38,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6401 1.10169C5.71335 -0.205453 4.31596 2.05773 3.94347 3.32703C3.50379 4.82528 4.47409 6.39905 5.73292 7.33498C8.05101 9.05846 9.42723 8.85976 10.9635 10.1566C11.8674 10.9196 12.3997 12.4695 11.7229 13.5598C11.1706 14.4494 10.8615 15.3746 7.97153 15.3746",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6914 1.12878C5.76461 -0.178366 4.31618 2.05765 3.94369 3.32695C3.50401 4.82519 4.4689 5.96876 6.20328 7.09376C7.9796 8.24597 9.31264 8.73439 11.0627 10.3125C11.9412 11.1047 12.3741 12.6458 11.6973 13.736C11.145 14.6257 10.7843 15.3763 7.89436 15.3763",
    stroke: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2611_2871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/Bot.df7c6e3a013c6be7fc34c9af585d6248.svg";
export { ForwardRef as ReactComponent };